import { useEffect, useState, forwardRef } from "react";

import processSchedule from "../../../utils/processSchedule";

const InstitutionItem = forwardRef(
  (
    {
      etablissement,
      selectedInstitution,
      setSelectedInstitution,
      filters,
      setMapscreen,
      scrollbarRef,
      allEtablissements,
      filtersKeys,
    },
    ref
  ) => {
    const [isSelected, setIsSelected] = useState(false);
    const schedule = processSchedule(etablissement.fullSchedule);

    //--- Get overlayScrollbar Instance from the parent component
    let scrollbarInstance = {};
    if (scrollbarRef.current) {
      scrollbarInstance = scrollbarRef.current.osInstance();
    }

    //--- Scroll the selected institution to the top
    const scrollTo = (etablissementArray, idToCompare, e) => {
      const i = etablissementArray.findIndex((elt) => elt.id == idToCompare);
      const { viewport } = scrollbarInstance.elements();
      viewport.scrollTo({
        top: e.currentTarget.offsetTop,
        behavior: "smooth",
      });
    };

    //--- Control if current item is active or not
    useEffect(() => {
      if (selectedInstitution) {
        if (selectedInstitution.id === etablissement.id) {
          setIsSelected(true);
        } else {
          setIsSelected(false);
        }
      } else {
        setIsSelected(false);
      }
    }, [selectedInstitution]);

    //--- Trigger auto-scroll, set the selected item state
    const handleShowInstitution = (etablissement, e) => {
      scrollTo(allEtablissements, etablissement.id, e);
      setSelectedInstitution((prev) => {
        if (prev) {
          if (prev.id === etablissement.id) {
            return null;
          } else {
            return etablissement;
          }
        } else {
          return etablissement;
        }
      });
    };

    return (
      <div
        className={`institution__item ${isSelected ? "active" : ""} d-flex`}
        key={etablissement.id}
        onClick={(e) => handleShowInstitution(etablissement, e)}
        ref={ref}
      >
        <div className="px-2">
          <img
            src={etablissement.picture}
            alt=""
            style={{ height: "40px", width: "40px" }}
          />
        </div>
        <div className="d-flex flex-column">
          <div>{etablissement.name}</div>
          <div>{schedule}</div>
        </div>
      </div>
    );
  }
);

export default InstitutionItem;
